import services from '@/services/ascentiaServiceIndex'
import { ATTACHMENT_CONSTS as AC } from '../consts'

const state = {
  attachmentErrors: [],
  attachmentTypes: [],
  uploadedAttachments: [],
  uploadErrorByType: [
    {
      type: 1,
      files: [],
    },
    {
      type: 2,
      files: [],
    },
    {
      type: 3,
      files: [],
    },
  ],
  attachmentsToRemove: [],
  attachmentsToUpdate: [],
}

const checkForDoubles = (array, item) => {
  let double = null
  if (array.length) {
    const inArray = array.filter(arrayItem => arrayItem.id === item.id).pop()
    double = inArray
  }
  if (!double) array.push(item)
  else array.splice(getIndexOfAttachment(array, double), 1, item)
}

const getIndexOfAttachment = (attachments, item) => {
  let attachmentIndex = null
  if (attachments) {
    attachmentIndex = attachments.findIndex(
      attachment => attachment.id === item,
    )
  }
  return attachmentIndex
}

const mutations = {
  [AC.UPDATE_ATTACHMENT_TYPES]: (state, data) => (state.attachmentTypes = data),
  [AC.UPDATE_UPLOADED_ATTACHMENTS]: (state, data) =>
    state.uploadedAttachments.push(data),
  [AC.UPDATE_SAVE_ATTACHMENT_ERROR]: (state, data) => {
    state.uploadErrorByType.forEach(item => {
      item.files = []
    })
    if (data) {
      state.uploadErrorByType.forEach(item => {
        if (item.type === data.attachmentTypeId) item.files.push(data)
      })
    }
  },
  [AC.UPDATE_REMOVED_ATTACHMENTS]: (state, attachmentId) => {
    const attachmentInUpdates = getIndexOfAttachment(
      state.attachmentsToUpdate,
      attachmentId,
    )
    const attachmentInUploads = getIndexOfAttachment(
      state.uploadedAttachments,
      attachmentId,
    )
    if (attachmentInUpdates >= 0)
      state.attachmentsToUpdate.splice(attachmentInUpdates, 1)
    if (attachmentInUploads >= 0)
      state.uploadedAttachments.splice(attachmentInUploads, 1)
    state.attachmentsToRemove.push(attachmentId)
  },
  [AC.UPDATE_UPDATED_ATTACHMENTS]: (state, attachment) =>
    checkForDoubles(state.attachmentsToUpdate, attachment),
  [AC.UPDATE_ALL_ATTACHMENTS]: state => (
    (state.uploadedAttachments = []),
    (state.attachmentsToRemove = []),
    (state.attachmentsToUpdate = [])
  ),
  [AC.UPDATE_ATTACHMENT_ERRORS]: (state, data) =>
    (state.attachmentErrors = data
      ? [...new Set(state.attachmentErrors.concat(data))]
      : []),
}

const actions = {
  // THESE ACTIONS ARE BEING USED TO KEEP STATE
  [AC.SAVE_REMOVED_ATTACHMENT]({ commit }, attachmentId) {
    commit(AC.UPDATE_REMOVED_ATTACHMENTS, attachmentId)
  },
  [AC.SAVE_UPDATED_ATTACHMENT]({ commit }, attachment) {
    commit(AC.UPDATE_UPDATED_ATTACHMENTS, attachment)
  },
  [AC.RESET_ATTACHMENTS]({ commit }) {
    commit(AC.UPDATE_ALL_ATTACHMENTS)
  },
  [AC.RESET_ATTACHMENT_ERRORS]({ commit }) {
    commit(AC.UPDATE_SAVE_ATTACHMENT_ERROR, null)
  },

  async [AC.GET_ATTACHMENT_TYPES]({ commit }) {
    try {
      const response = await services.attachments.getData('attachmentTypesData')
      commit(AC.UPDATE_ATTACHMENT_TYPES, response.data)
    } catch (err) {
      commit(AC.UPDATE_ATTACHMENT_ERRORS, 'attachment')
    }
  },

  // eslint-disable-next-line no-unused-vars
  async [AC.GET_ATTACHMENTS_BY_FILETYPE]({ commit }, fileTypeId) {
    try {
      const attachments = await services.attachments.getData(
        'attachmentsByTypeData',
        fileTypeId,
        true,
      )
      return attachments.data
    } catch (error) {
      console.log(AC.GET_ATTACHMENTS_BY_FILETYPE + ': error ' + error)
    }
  },

  // THIS CALL IS MADE WHEN AN ATTACHMENT IS UPLOADED
  async [AC.SAVE_ATTACHMENT]({ commit, dispatch }, attachmentBody) {
    commit(AC.UPDATE_SAVE_ATTACHMENT_ERROR, null)
    try {
      const attachment = await services.attachments.saveData(
        'attachments',
        attachmentBody,
      )
      if (attachment.status === 201) {
        const attachmentList = await dispatch(
          AC.GET_ATTACHMENTS_BY_FILETYPE,
          attachmentBody.attachmentTypeId,
        )
        const id = parseInt(attachment.headers.location.split('/').pop())
        const newAttachment = attachmentList?.find(item => item.id === id)
        commit(AC.UPDATE_UPLOADED_ATTACHMENTS, newAttachment)
      }
    } catch (err) {
      commit(AC.UPDATE_SAVE_ATTACHMENT_ERROR, {
        attachmentTypeId: attachmentBody.attachmentTypeId,
        name: attachmentBody.fileUpload.name,
      })
      return err
    }
  },

  // eslint-disable-next-line no-unused-vars
  async [AC.CANCEL_ATTACHMENT_UPLOAD]({ commit }, attachmentToCancel) {
    await services.attachments.saveData('attachments', attachmentToCancel)
  },

  // eslint-disable-next-line no-unused-vars
  async [AC.DELETE_ATTACHMENTS]({ commit }, attachments) {
    try {
      await services.attachments.deleteData('attachments', attachments)
    } catch (err) {
      return err
    }
  },

  // FOR DOWNLOADING ATTACHMENTS
  // eslint-disable-next-line no-unused-vars
  async [AC.GET_ATTACHMENT]({ commit }, attachment) {
    await services.attachments.getData('downloadAttachment', attachment)
  },

  [AC.RESET_ATTACHMENT_ERRORS]({ commit }) {
    commit(AC.UPDATE_ATTACHMENT_ERRORS)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
